var _g, _tspan;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoGeneratedPosts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 750 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-6"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 254.135712, -22.884258)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -265.366913, 50.881565)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 308,
    y: 329,
    style: {
      fill: "rgb(0, 171, 101)",
      fontFamily: "Poppins",
      fontSize: 22,
      fontWeight: 700,
      whiteSpace: "pre",
      textAnchor: "middle"
    },
    transform: "rotate(-22,308,329)"
  }, "NO GENERATED", _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 308,
    dy: "1.2em"
  }, "POSTS"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoGeneratedPosts);
export default __webpack_public_path__ + "static/media/no-generated-posts.5f84c9886a1ab1416c87bb3ed79cb30c.svg";
export { ForwardRef as ReactComponent };